export const icons = {
  ilon: require('@/assets/icon/users/user-ilon.svg/?esModule=false'),
  egor: require('@/assets/icon/users/user-alex.svg/?esModule=false'),
  semen: require('@/assets/icon/users/user-semen.svg/?esModule=false'),
  julia: require('@/assets/icon/users/user-julia.svg/?esModule=false'),
  tolya: require('@/assets/icon/users/user-tolya.svg/?esModule=false'),
  luda: require('@/assets/icon/users/user-luda.svg/?esModule=false'),
}
